import type { JSX } from 'preact';
import { Icon, type IconName } from './Icon';

export interface IconButtonProps extends Omit<JSX.ButtonHTMLAttributes<HTMLButtonElement>, 'label'> {
  icon: IconName;
  label: string; // required — icon-only buttons must have an accessible name
  bordered?: boolean;
  size?: number;
}

/** A square, icon-only button. `label` is mandatory and becomes the accessible name via aria-label. */
export function IconButton({ icon, label, bordered = false, size = 20, class: className, ...rest }: IconButtonProps) {
  const classes = ['c-icon-btn', bordered ? 'c-icon-btn--bordered' : '', className].filter(Boolean).join(' ');
  return (
    <button type="button" class={classes} aria-label={label} title={label} {...rest}>
      <Icon name={icon} size={size} />
    </button>
  );
}
